enum STATUS_NAME {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
}
export { STATUS_NAME };
